<div class="flex flex-col">
  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
              'bg-gray-600': sharedService.userTheme === 'dark',
              'bg-indigo-50': sharedService.userTheme === 'light'}">

      <div class="flex flex-row padding10">
        <h5>License Cash Reports</h5>
      </div>
    </mat-card>
  </div>

  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
      'bg-gray-600': sharedService.userTheme === 'dark',
      'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <form [formGroup]="reportGroup" class="w-full">
          <div class="flex flex-col">

            <div style="overflow-x:auto">
              <div class="flex flex-row">
                <table class="mat-elevation-z8 w-full">
                  <tr class="">
                    <th>Report Name </th>
                    <th>Description</th>
                    <th>
                    </th>
                  </tr>
                  <tr>
                    <td>Monthly License Cash Detail Report</td>
                    <td>Cash Reconciliation Report</td>
                    <td>
                      <div class="flex flex-row">
                        <mat-form-field>
                          <mat-label>Month</mat-label>
                          <mat-select formControlName="Month">
                            <mat-option value=""></mat-option>
                            <mat-option *ngFor="let types of months" [value]="types.key">{{types.value}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                          <mat-label>Year</mat-label>
                          <mat-select formControlName="Year">
                            <mat-option value=""></mat-option>
                            <mat-option *ngFor="let types of years" [value]="types.key">{{types.value}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <div>
                          <button type="button" mat-raised-button color="primary" (click)="licenseCashReport()">
                            Run Report
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>HST Non-Renewal</td>
                    <td>Did not pay license fee for upcoming cycle</td>
                    <td>
                      <button type="button" mat-raised-button color="primary" (click)="hstReport()">
                        Run Report
                      </button>
                  </tr>
                  <tr>
                    <td>SOA Non-Renewal</td>
                    <td>Did not pay license fee for upcoming cycle</td>
                    <td>
                      <button type="button" mat-raised-button color="primary" (click)="soaReport()">
                        Run Report
                      </button>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </form>
      </mat-card-content>

    </mat-card>
  </div>

  <!-- Cash Report -->
  <kendo-pdf-export #pdf paperSize="letter" [scale]="0.6" margin="1cm">

    <div class="flex flex-col" *ngIf="reportMode == 'licenseCash'">
      <div class="flex flex-row">
        <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
        'bg-gray-700': sharedService.userTheme === 'dark',
        'bg-indigo-50': sharedService.userTheme === 'light'}">
          <mat-card-content>
            <div class="flex flex-col">
              <h5>Cash reconciliation report for {{mon}}/{{yr}} ({{licenseCashData.length}})</h5>
              <div class="flex flex-row" style="padding-bottom: 10px;" *ngIf="licenseCashData.length > 0">
                <div style="padding-right: 10px;">
                  <button type="button" mat-raised-button (click)="csv('licenseCash')">
                    CSV
                  </button>
                </div>
                <!-- <div>
                  <button type="button" mat-raised-button (click)="pdf.saveAs('LicenseCash.pdf')">
                    PDF
                  </button>
                </div> -->
              </div>
              <div style="overflow-x:auto">
                <div class="flex flex-row" *ngIf="licenseCashData.length > 0">
                  <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                    class="mat-elevation-z8 w-full">
                    <ng-container matColumnDef="stateNumber">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>State Number</th>
                      <td mat-cell *matCellDef="let change">{{change.stateNumber}}</td>
                    </ng-container>
                    <ng-container matColumnDef="cliaNumber">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Clia Number</th>
                      <td mat-cell *matCellDef="let change">{{change.cliaNumber}}</td>
                    </ng-container>
                    <ng-container matColumnDef="labName">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Lab Name</th>
                      <td mat-cell *matCellDef="let change">{{change.labName}}</td>
                    </ng-container>
                    <ng-container matColumnDef="labTypeName">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Lab Type</th>
                      <td mat-cell *matCellDef="let change">{{change.labTypeName}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="licensedDate">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>License Date</th>
                      <td mat-cell *matCellDef="let change">{{change.licensedDate}}</td>
                    </ng-container>
                    <ng-container matColumnDef="cashDate">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Cash Date</th>
                      <td mat-cell *matCellDef="let change">{{change.cashDate}}</td>
                    </ng-container>
                    <ng-container matColumnDef="crNumber">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>CR Number</th>
                      <td mat-cell *matCellDef="let change">{{change.crNumber}}</td>
                    </ng-container>
                    <ng-container matColumnDef="amountPaid">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount Paid</th>
                      <td mat-cell *matCellDef="let change">{{change.amountPaid}}</td>
                    </ng-container>
                    <ng-container matColumnDef="credit">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Credit</th>
                      <td mat-cell *matCellDef="let change">{{change.credit}}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>
                </div>
              </div>
            </div>

          </mat-card-content>

        </mat-card>
      </div>

    </div>

    <!-- HST Report -->
    <div class="flex flex-col" *ngIf="reportMode == 'hst'">
      <div class="flex flex-row">
        <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
        'bg-gray-700': sharedService.userTheme === 'dark',
        'bg-indigo-50': sharedService.userTheme === 'light'}">
          <mat-card-content>
            <div class="flex flex-col">
              <h5>HST Non-Renewal for {{date}} ({{licenseCashData.length}})</h5>
              <div class="flex flex-row" style="padding-bottom: 10px;" *ngIf="licenseCashData.length > 0">
                <div style="padding-right: 10px;">
                  <button type="button" mat-raised-button (click)="csv('hst')">
                    CSV
                  </button>
                </div>
                <!-- <div>
                  <button type="button" mat-raised-button (click)="pdf.saveAs('HST.pdf')">
                    PDF
                  </button>
                </div> -->
              </div>
              <div style="overflow-x:auto">
                <div class="flex flex-row" *ngIf="licenseCashData.length > 0">
                  <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                    class="mat-elevation-z8 w-full">
                    <ng-container matColumnDef="stateNumber">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>State Number</th>
                      <td mat-cell *matCellDef="let item">{{item.stateNumber}}</td>
                    </ng-container>
                    <ng-container matColumnDef="cliaNumber">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Clia Number</th>
                      <td mat-cell *matCellDef="let item">{{item.cliaNumber}}</td>
                    </ng-container>
                    <ng-container matColumnDef="labName">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Lab Name</th>
                      <td mat-cell *matCellDef="let item">{{item.labName}}</td>
                    </ng-container>
                    <ng-container matColumnDef="expirationDate">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Expiration Date</th>
                      <td mat-cell *matCellDef="let item">{{item.expirationDate}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="siteCity">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Site City</th>
                      <td mat-cell *matCellDef="let item">{{item.siteCity}}</td>
                    </ng-container>
                    <ng-container matColumnDef="amountPending">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount Pending</th>
                      <td mat-cell *matCellDef="let item">{{item.amountPending}}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
                  </table>
                </div>
              </div>
            </div>

          </mat-card-content>

        </mat-card>
      </div>

    </div>

    <!-- SOA Report -->
    <div class="flex flex-col" *ngIf="reportMode == 'soa'">
      <div class="flex flex-row">
        <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
        'bg-gray-700': sharedService.userTheme === 'dark',
        'bg-indigo-50': sharedService.userTheme === 'light'}">
          <mat-card-content>
            <div class="flex flex-col">
              <h5>SOA Non-Renewal for {{date}} ({{licenseCashData.length}})</h5>
              <div class="flex flex-row" style="padding-bottom: 10px;" *ngIf="licenseCashData.length > 0">
                <div style="padding-right: 10px;">
                  <button type="button" mat-raised-button (click)="csv('soa')">
                    CSV
                  </button>
                </div>
                <!-- <div>
                  <button type="button" mat-raised-button (click)="pdf.saveAs('SOA.pdf')">
                    PDF
                  </button>
                </div> -->
              </div>
              <div style="overflow-x:auto">
                <div class="flex flex-row" *ngIf="licenseCashData.length > 0">
                  <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                    class="mat-elevation-z8 w-full">
                    <ng-container matColumnDef="stateNumber">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>State Number</th>
                      <td mat-cell *matCellDef="let item">{{item.stateNumber}}</td>
                    </ng-container>
                    <ng-container matColumnDef="cliaNumber">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Clia Number</th>
                      <td mat-cell *matCellDef="let item">{{item.cliaNumber}}</td>
                    </ng-container>
                    <ng-container matColumnDef="labName">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Lab Name</th>
                      <td mat-cell *matCellDef="let item">{{item.labName}}</td>
                    </ng-container>
                    <ng-container matColumnDef="expirationDate">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Expiration Date</th>
                      <td mat-cell *matCellDef="let item">{{item.expirationDate}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="siteCity">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Site City</th>
                      <td mat-cell *matCellDef="let item">{{item.siteCity}}</td>
                    </ng-container>
                    <ng-container matColumnDef="amountPending">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount Pending</th>
                      <td mat-cell *matCellDef="let item">{{item.amountPending}}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
                  </table>
                </div>
              </div>
            </div>

          </mat-card-content>

        </mat-card>
      </div>

    </div>

  </kendo-pdf-export>

</div>